import { marked } from "marked"

// Linki otwierają się w nowym oknie
const renderer = new marked.Renderer()
const originalLink = renderer.link.bind(renderer)
renderer.link = function (token) {
  const html = originalLink(token)
  return html.replace("<a ", "<a target=\"_blank\" rel=\"noopener\" ")
}

marked.setOptions({ renderer, breaks: true, gfm: true })

// Konwersja markdown → HTML (marked + target=_blank na linkach)
// Escapuje surowy HTML w inputcie (zapobieganie XSS) przed parsowaniem markdown
export function simpleMarkdownToHtml(text) {
  if (!text) return ""
  const escaped = text.replace(/</g, "&lt;").replace(/>/g, "&gt;")
  return marked.parse(escaped)
}
